<template>
  <div class="setting-interview-date-container">
    <section class="right-container">
      <div>
        <p style="text-align: left; font-weight: bold">1. 面接日を選択してください。</p>
        <div style="display: flex; margin-top: 8px">
          <b-datepicker
            locale="ja-JP"
            :value="date"
            @input="emitDate($event)"
            :min-date="new Date()"
          />
        </div>
      </div>
      <div style="margin-top: 24px">
        <p style="text-align: left; font-weight: bold">2. 面接時間を選択してください。</p>
        <div style="display: flex; margin-top: 8px">
          <div>
            <div style="display: flex">
              <p>開始時刻:</p>
              <div
                class="time"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-left: 8px;
                "
              >
                <input
                  style="width: 48px; font-size: 16px; border: 1px gray solid"
                  class="hour-input"
                  :value="startHour"
                  @input="emitStartHour($event.target.value)"
                  type="number"
                  min="0"
                  max="23"
                />
                <span style="padding: 0 4px">時</span>
                <input
                  style="width: 48px; font-size: 16px; border: 1px gray solid"
                  class="minute-input"
                  :value="startMinute"
                  @input="emitStartMinute($event.target.value)"
                  type="number"
                  min="0"
                  max="45"
                  step="15"
                />
                <span style="padding-left: 4px">分</span>
              </div>
            </div>
            <div style="margin-top: 8px; display: flex">
              <p>終了時刻:</p>
              <div
                class="time"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin-left: 8px;
                "
              >
                <input
                  style="width: 48px; font-size: 16px; border: 1px gray solid"
                  class="hour-input"
                  :value="endHour"
                  @input="emitEndHour($event.target.value)"
                  type="number"
                  min="0"
                  max="23"
                />
                <span style="padding: 0 4px">時</span>
                <input
                  style="width: 48px; font-size: 16px; border: 1px gray solid"
                  class="minute-input"
                  :value="endMinute"
                  @input="emitEndMinute($event.target.value)"
                  type="number"
                  min="0"
                  max="45"
                  step="15"
                />
                <span style="padding-left: 4px">分</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="left-container">
      <div>
        <div v-if="calendarUserExists" style="margin-top: 24px">
          <p style="text-align: left; font-weight: bold">3. 登録先のカレンダーを選択してください。</p>
          <div class="calendar-users-wrapper">
            <template v-if="users.length > 0">
              <div class="tab-box-right" style="flex-wrap: wrap;">
                <SelectMemberTable
                  :isCalendar="true"
                  :users = users
                  :parameterHash="calParameter.user_hash"
                  :calParameter="calParameter"
                  :selfUser="user"
                  :calendarSettings="calendarSettings"
                  :isSync="true"
                  :isConfirm="false"
                  :usersStatusAPI="usersStatusAPI"
                  @changeShowEventSelfSelectMember="addSelfUserHash"
                  @createCalendarSettingsSelectMember="addUserHash"
                  style="height: 400px;"/>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CalendarAPIStatusUsers from '@/components/Calendar/organisms/CalendarAPIStatusUsers'
import CalendarAPIStatus from '@/views/DashBoard/Calendar/CalendarAPIStatus'
import Tooltip from '@/components/atoms/tooltips/Tooltip'
import SelectMemberTable from '@/components/molecules/tables/SelectMemberTable'

export default {
  components: {
    CalendarAPIStatusUsers,
    CalendarAPIStatus,
    Tooltip,
    SelectMemberTable
  },
  data () {
    return {
      updateInfo: null,
      isChangingInteviewDateModalActive: false,
    }
  },
  created () {
  },
  props: {
    seeker: {
      type: Object,
      required: true,
    },
    getInterviewDate: {
      type: Function,
      required: true,
    },
    date: {
      value: { type: Date, required: true, default: null },
    },
    startHour: {
      type: String,
      required: true,
    },
    startMinute: {
      type: String,
      required: true,
    },
    endHour: {
      type: String,
      required: true,
    },
    endMinute: {
      type: String,
      required: true,
    },
    setDate: {
      type: Function,
      required: true,
    },
    users: {
      type: Array,
      required: false,
    },
    user: {
      type: Object,
      required: false,
    },
    calendarSettings: {
      type: Array,
      required: true,
    },
    changeShowEvent: {
      type: Function,
      required: true,
    },
    changeShowEventSelf: {
      type: Function,
      required: true,
    },
    createCalendarSettings: {
      type: Function,
      required: true,
    },
    isEditableCalendarSettings: {
      type: Function,
      required: true,
    },
    calendarUserExists: {
      type: Boolean,
      required: true
    },
    calParameter: {
      type    : Object,
      required: true
    },
    addSelfUserHash: {
      type    : Function,
      required: true
    },
    addUserHash: {
      type    : Function,
      required: true
    },
    usersStatusAPI: {
      type: Array,
      required: true
    }
  },
  methods: {
    emitDate(value) {
      this.$emit('emitDate', value)
    },
    emitStartHour(value) {
      this.$emit('emitStartHour', value)
    },
    emitStartMinute(value) {
      this.$emit('emitStartMinute', value)
    },
    emitEndHour(value) {
      this.$emit('emitEndHour', value)
    },
    emitEndMinute(value) {
      this.$emit('emitEndMinute', value)
    },
    openCalendar(value) {
      this.$emit('openCalendar', value)
    },
  },
}
</script>

<style scoped lang="scss">
.setting-interview-date-container {
  height: 500px;
  padding: 24px;
  overflow: auto;
  display: flex;
  justify-content: space-between;
  .left-container {
    width: 60%;
    padding-right: 8px;
  }
  .right-container {
    width: 40%;
    text-align: center;
    padding-left: 8px;
  }
  .calendar-users-wrapper {
    margin-top: 8px;
    height: 400px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .calendar-users-wrapper::-webkit-scrollbar {
    width: 8px;
  }
  .my-calendar {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/emails/ChangingInterviewDate.vue